import React from 'react';
import { SkeletonLine } from '@one-thd/sui-atomic-components';
export var SkeletonHeader = function (_a) {
    var isMobile = _a.isMobile;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-col-span-1 sui-order-1 md:sui-col-span-2 md:sui-order-1 sui-leading-9" },
            React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-items-start sui-whitespace-nowrap" },
                React.createElement("div", { className: "sui-w-96" },
                    React.createElement(SkeletonLine, { variant: "heading" })))),
        React.createElement("div", { className: "sui-col-span-1 sui-order-1 sui-my-6" },
            React.createElement("div", { className: "sm:sui-w-32 md:sui-w-96 lg:sui-w-96" },
                React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 4 }))),
        React.createElement("div", { className: "sui-col-span-1 md:sui-mt-5 sui-order-3 md:sui-col-span-1  md:sui-order-2 ".concat(!isMobile ? 'sui-ml-12' : '') },
            React.createElement("div", { className: "sui-flex sui-flex-col lg:sui-gap-2 sm:sui-gap-1" },
                React.createElement("div", { className: "sm:sui-w-32 md:sui-w-96 lg:sui-w-96" },
                    React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 4 }))))));
};
